import { render, staticRenderFns } from "./HeaderGarage.vue?vue&type=template&id=4cea942e&"
import script from "./HeaderGarage.vue?vue&type=script&lang=ts&"
export * from "./HeaderGarage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports